var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNttdataPowered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1596.9872 223.29029",
    width: 1596.9872,
    height: 223.29029,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style1"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;stroke:#000000;stroke-miterlimit:10;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
    className: "st0",
    transform: "scale(1.0001799,0.50828658)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 1595.7,
    height: 438.29999,
    id: "rect1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    transform: "matrix(0.73623987,0,0,0.72846508,508.42279,-43.228743)",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 318.3,85.5 c -12.8,0 -25.4,2.8 -34.3,6.4 -8.9,-3.6 -21.5,-6.4 -34.3,-6.4 -56.4,0 -107.4,53.4 -107.4,126.6 0,79.8 65.2,141.6 141.7,141.6 76.5,0 141.7,-61.7 141.7,-141.6 0,-73.2 -51,-126.6 -107.4,-126.6 z M 284,129 c 10.9,6.5 25.2,25.2 25.2,46.4 0,15.5 -10.2,27.7 -25.2,27.7 -15,0 -25.2,-12.2 -25.2,-27.7 -0.1,-21.2 14.3,-39.9 25.2,-46.4 z m 0,189.8 c -58.5,0 -106.9,-47.1 -106.9,-107.4 0,-55.1 39.8,-92.7 71,-91.3 -14.8,14.7 -23.8,36.2 -23.8,57 0,35.8 28.4,60.9 59.7,60.9 31.3,0 59.7,-25.1 59.7,-60.9 0,-20.8 -9,-42.3 -23.8,-57 31.2,-1.4 71,36.2 71,91.3 0,60.4 -48.4,107.4 -106.9,107.4 z",
    id: "path1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 629.8,146.6 v 29.2 c 0,0 41.3,0 44.5,0 0,3.2 0,109.5 0,109.5 h 31.5 c 0,0 0,-106.2 0,-109.5 3.1,0 44.5,0 44.5,0 v -29.2 z",
    id: "path2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 1148.1,146.6 h -79.3 V 176 h 77.2 c 11.3,0 15.7,5.2 15.7,18.4 0,0.1 0,3.8 0,4.9 -3.2,0 -64,0 -64,0 -24.3,0 -36.4,12.2 -36.4,39.7 v 6.5 c 0,28.3 12.5,39.6 37.8,39.6 h 93.8 V 194 c 0.1,-34.8 -11.5,-47.4 -44.8,-47.4 z m -45.7,109 c -4.8,0 -10.1,-2.4 -10.1,-14.3 0,-11.9 5.3,-14 10.1,-14 0,0 56.2,0 59.4,0 v 28.3 c -3.2,0 -59.4,0 -59.4,0 z",
    id: "path3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 1409.6,146.6 h -79.3 V 176 h 77.2 c 11.3,0 15.7,5.2 15.7,18.4 0,0.1 0,3.8 0,4.9 -3.2,0 -64,0 -64,0 -24.3,0 -36.4,12.2 -36.4,39.7 v 6.5 c 0,28.3 12.5,39.6 37.8,39.6 h 93.8 V 194 c 0,-34.8 -11.5,-47.4 -44.8,-47.4 z m -45.7,109 c -4.8,0 -10.1,-2.4 -10.1,-14.3 0,-11.9 5.3,-14 10.1,-14 0,0 56.2,0 59.4,0 v 28.3 c -3.2,0 -59.4,0 -59.4,0 z",
    id: "path4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 760.2,146.6 v 29.2 c 0,0 41.4,0 44.5,0 0,3.2 0,109.5 0,109.5 h 31.5 c 0,0 0,-106.2 0,-109.5 3.1,0 44.5,0 44.5,0 v -29.2 z",
    id: "path5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 1199.3,146.6 v 29.2 c 0,0 41.3,0 44.5,0 0,3.2 0,109.5 0,109.5 h 31.5 c 0,0 0,-106.2 0,-109.5 3.1,0 44.5,0 44.5,0 v -29.2 z",
    id: "path6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 1049.2,236.7 v -41.5 c 0,-36.3 -14.1,-48.6 -45.9,-48.6 H 919 v 138.6 h 85.8 c 33.7,0 44.4,-16.7 44.4,-48.5 z m -32.2,0.6 c 0,13.3 -4.5,18.4 -15.8,18.4 0,0 -47.6,0 -50.7,0 v -79.6 c 3.1,0 50.7,0 50.7,0 11.3,0 15.8,5.2 15.8,18.4 0,0.2 0,42.8 0,42.8 z",
    id: "path7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 585.4,252.2 c -0.7,-1.3 -42.8,-83.3 -47.9,-91.3 -5.9,-9.3 -13.2,-15.8 -27,-15.8 -12.9,0 -28.1,5.7 -28.1,36.6 v 103.7 h 31.1 c 0,0 0,-80.2 0,-86.5 0,-6.2 -0.4,-15.4 -0.5,-17.2 -0.1,-1.5 0,-3 0.8,-3.4 0.9,-0.5 1.8,0.3 2.4,1.5 0.6,1.2 39.6,78.3 47.9,91.3 5.9,9.3 13.2,15.8 27,15.8 12.8,0 28.1,-5.7 28.1,-36.6 V 146.6 h -31 c 0,0 0,80.2 0,86.5 0,6.2 0.4,15.4 0.5,17.3 0.1,1.5 0,3 -0.8,3.4 -1,0.4 -1.9,-0.4 -2.5,-1.6 z",
    id: "path8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1-0",
    transform: "matrix(0.74108552,0,0,0.73325956,499.37029,-44.175783)",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9-3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 318.3,85.5 c -12.8,0 -25.4,2.8 -34.3,6.4 -8.9,-3.6 -21.5,-6.4 -34.3,-6.4 -56.4,0 -107.4,53.4 -107.4,126.6 0,79.8 65.2,141.6 141.7,141.6 76.5,0 141.7,-61.7 141.7,-141.6 0,-73.2 -51,-126.6 -107.4,-126.6 z M 284,129 c 10.9,6.5 25.2,25.2 25.2,46.4 0,15.5 -10.2,27.7 -25.2,27.7 -15,0 -25.2,-12.2 -25.2,-27.7 -0.1,-21.2 14.3,-39.9 25.2,-46.4 z m 0,189.8 c -58.5,0 -106.9,-47.1 -106.9,-107.4 0,-55.1 39.8,-92.7 71,-91.3 -14.8,14.7 -23.8,36.2 -23.8,57 0,35.8 28.4,60.9 59.7,60.9 31.3,0 59.7,-25.1 59.7,-60.9 0,-20.8 -9,-42.3 -23.8,-57 31.2,-1.4 71,36.2 71,91.3 0,60.4 -48.4,107.4 -106.9,107.4 z",
    id: "path1-5",
    style: {
      clipRule: "evenodd",
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g8-6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 629.8,146.6 v 29.2 c 0,0 41.3,0 44.5,0 0,3.2 0,109.5 0,109.5 h 31.5 c 0,0 0,-106.2 0,-109.5 3.1,0 44.5,0 44.5,0 v -29.2 z",
    id: "path2-3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 1148.1,146.6 h -79.3 V 176 h 77.2 c 11.3,0 15.7,5.2 15.7,18.4 0,0.1 0,3.8 0,4.9 -3.2,0 -64,0 -64,0 -24.3,0 -36.4,12.2 -36.4,39.7 v 6.5 c 0,28.3 12.5,39.6 37.8,39.6 h 93.8 V 194 c 0.1,-34.8 -11.5,-47.4 -44.8,-47.4 z m -45.7,109 c -4.8,0 -10.1,-2.4 -10.1,-14.3 0,-11.9 5.3,-14 10.1,-14 0,0 56.2,0 59.4,0 v 28.3 c -3.2,0 -59.4,0 -59.4,0 z",
    id: "path3-9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 1409.6,146.6 h -79.3 V 176 h 77.2 c 11.3,0 15.7,5.2 15.7,18.4 0,0.1 0,3.8 0,4.9 -3.2,0 -64,0 -64,0 -24.3,0 -36.4,12.2 -36.4,39.7 v 6.5 c 0,28.3 12.5,39.6 37.8,39.6 h 93.8 V 194 c 0,-34.8 -11.5,-47.4 -44.8,-47.4 z m -45.7,109 c -4.8,0 -10.1,-2.4 -10.1,-14.3 0,-11.9 5.3,-14 10.1,-14 0,0 56.2,0 59.4,0 v 28.3 c -3.2,0 -59.4,0 -59.4,0 z",
    id: "path4-9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 760.2,146.6 v 29.2 c 0,0 41.4,0 44.5,0 0,3.2 0,109.5 0,109.5 h 31.5 c 0,0 0,-106.2 0,-109.5 3.1,0 44.5,0 44.5,0 v -29.2 z",
    id: "path5-7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 1199.3,146.6 v 29.2 c 0,0 41.3,0 44.5,0 0,3.2 0,109.5 0,109.5 h 31.5 c 0,0 0,-106.2 0,-109.5 3.1,0 44.5,0 44.5,0 v -29.2 z",
    id: "path6-4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 1049.2,236.7 v -41.5 c 0,-36.3 -14.1,-48.6 -45.9,-48.6 H 919 v 138.6 h 85.8 c 33.7,0 44.4,-16.7 44.4,-48.5 z m -32.2,0.6 c 0,13.3 -4.5,18.4 -15.8,18.4 0,0 -47.6,0 -50.7,0 v -79.6 c 3.1,0 50.7,0 50.7,0 11.3,0 15.8,5.2 15.8,18.4 0,0.2 0,42.8 0,42.8 z",
    id: "path7-1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 585.4,252.2 c -0.7,-1.3 -42.8,-83.3 -47.9,-91.3 -5.9,-9.3 -13.2,-15.8 -27,-15.8 -12.9,0 -28.1,5.7 -28.1,36.6 v 103.7 h 31.1 c 0,0 0,-80.2 0,-86.5 0,-6.2 -0.4,-15.4 -0.5,-17.2 -0.1,-1.5 0,-3 0.8,-3.4 0.9,-0.5 1.8,0.3 2.4,1.5 0.6,1.2 39.6,78.3 47.9,91.3 5.9,9.3 13.2,15.8 27,15.8 12.8,0 28.1,-5.7 28.1,-36.6 V 146.6 h -31 c 0,0 0,80.2 0,86.5 0,6.2 0.4,15.4 0.5,17.3 0.1,1.5 0,3 -0.8,3.4 -1,0.4 -1.9,-0.4 -2.5,-1.6 z",
    id: "path8-3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "g10-9",
    transform: "matrix(7.3760067,0,0,7.2981151,21.20067,22.591881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1.118,19.335 v -3.12 h 2.067 c 1.118,0 1.9825,-0.3077 2.5935,-0.923 0.611,-0.6153 0.9165,-1.443 0.9165,-2.483 0,-1.0487 -0.30333,-1.8698 -0.91,-2.4635 C 5.17833,9.75184 4.30733,9.455 3.172,9.455 H 0 v 9.88 z M 3.055,15.227 H 1.118 v -4.784 h 1.95 c 0.84067,0 1.46683,0.2037 1.8785,0.611 0.41167,0.4073 0.6175,0.9923 0.6175,1.755 0,0.754 -0.208,1.3455 -0.624,1.7745 -0.416,0.429 -1.04433,0.6435 -1.885,0.6435 z m 8.3,4.238 c 0.6327,0 1.2025,-0.1473 1.7095,-0.442 0.507,-0.2947 0.9057,-0.7063 1.196,-1.235 0.2903,-0.5287 0.4355,-1.1267 0.4355,-1.794 0,-0.6673 -0.1452,-1.2653 -0.4355,-1.794 -0.2903,-0.5287 -0.689,-0.9425 -1.196,-1.2415 -0.507,-0.299 -1.0768,-0.4485 -1.7095,-0.4485 -0.6327,0 -1.2025,0.1495 -1.7095,0.4485 -0.507,0.299 -0.90567,0.7128 -1.196,1.2415 -0.29033,0.5287 -0.4355,1.1267 -0.4355,1.794 0,0.6673 0.14517,1.2653 0.4355,1.794 0.29033,0.5287 0.689,0.9403 1.196,1.235 0.507,0.2947 1.0768,0.442 1.7095,0.442 z m 0,-0.975 c -0.416,0 -0.7952,-0.1018 -1.1375,-0.3055 -0.34233,-0.2037 -0.611,-0.494 -0.806,-0.871 -0.195,-0.377 -0.2925,-0.8168 -0.2925,-1.3195 0,-0.5027 0.0975,-0.9447 0.2925,-1.326 0.195,-0.3813 0.46367,-0.6738 0.806,-0.8775 0.3423,-0.2037 0.7215,-0.3055 1.1375,-0.3055 0.416,0 0.7952,0.1018 1.1375,0.3055 0.3423,0.2037 0.611,0.4962 0.806,0.8775 0.195,0.3813 0.2925,0.8233 0.2925,1.326 0,0.5027 -0.0975,0.9425 -0.2925,1.3195 -0.195,0.377 -0.4637,0.6673 -0.806,0.871 C 12.1502,18.3882 11.771,18.49 11.355,18.49 Z m 7.585,0.845 1.625,-5.278 1.625,5.278 h 1.209 l 2.08,-6.695 h -1.131 l -1.586,5.486 -1.677,-5.486 h -1.04 l -1.677,5.499 -1.586,-5.499 h -1.131 l 2.067,6.695 z m 10.822,0.13 c 0.7367,0 1.3693,-0.1842 1.898,-0.5525 0.5287,-0.3683 0.923,-0.8818 1.183,-1.5405 l -1.079,-0.13 c -0.182,0.3813 -0.442,0.6847 -0.78,0.91 -0.338,0.2253 -0.7367,0.338 -1.196,0.338 -0.5807,0 -1.0768,-0.182 -1.4885,-0.546 C 27.8878,17.58 27.643,17.0773 27.565,16.436 h 5.343 v -0.442 c 0,-0.65 -0.1235,-1.2372 -0.3705,-1.7615 -0.247,-0.5243 -0.611,-0.9425 -1.092,-1.2545 -0.481,-0.312 -1.0638,-0.468 -1.7485,-0.468 -0.6587,0 -1.235,0.1452 -1.729,0.4355 -0.494,0.2903 -0.8732,0.6955 -1.1375,1.2155 -0.2643,0.52 -0.3965,1.1137 -0.3965,1.781 0,0.6933 0.1408,1.3065 0.4225,1.8395 0.2817,0.533 0.6738,0.9468 1.1765,1.2415 0.5027,0.2947 1.079,0.442 1.729,0.442 z M 31.777,15.5 h -4.212 c 0.0607,-0.6413 0.2773,-1.1375 0.65,-1.4885 0.3727,-0.351 0.8623,-0.5265 1.469,-0.5265 0.5893,0 1.0682,0.1733 1.4365,0.52 0.3683,0.3467 0.5872,0.845 0.6565,1.495 z m 4.14,3.835 v -3.146 c 0,-0.754 0.1387,-1.3693 0.416,-1.846 0.2773,-0.4767 0.7193,-0.715 1.326,-0.715 0.1907,0 0.3857,0.0217 0.585,0.065 l 0.078,-1.157 C 38.2353,12.5187 38.088,12.51 37.88,12.51 c -0.416,0 -0.7952,0.1148 -1.1375,0.3445 C 36.4002,13.0842 36.125,13.42 35.917,13.862 L 35.813,12.64 h -1.001 v 6.695 z m 6.662,0.13 c 0.7367,0 1.3693,-0.1842 1.898,-0.5525 0.5287,-0.3683 0.923,-0.8818 1.183,-1.5405 l -1.079,-0.13 c -0.182,0.3813 -0.442,0.6847 -0.78,0.91 -0.338,0.2253 -0.7367,0.338 -1.196,0.338 -0.5807,0 -1.0768,-0.182 -1.4885,-0.546 C 40.7048,17.58 40.46,17.0773 40.382,16.436 h 5.343 v -0.442 c 0,-0.65 -0.1235,-1.2372 -0.3705,-1.7615 -0.247,-0.5243 -0.611,-0.9425 -1.092,-1.2545 -0.481,-0.312 -1.0638,-0.468 -1.7485,-0.468 -0.6587,0 -1.235,0.1452 -1.729,0.4355 -0.494,0.2903 -0.8732,0.6955 -1.1375,1.2155 -0.2643,0.52 -0.3965,1.1137 -0.3965,1.781 0,0.6933 0.1408,1.3065 0.4225,1.8395 0.2817,0.533 0.6738,0.9468 1.1765,1.2415 0.5027,0.2947 1.079,0.442 1.729,0.442 z M 44.594,15.5 h -4.212 c 0.0607,-0.6413 0.2773,-1.1375 0.65,-1.4885 0.3727,-0.351 0.8623,-0.5265 1.469,-0.5265 0.5893,0 1.0682,0.1733 1.4365,0.52 0.3683,0.3467 0.5872,0.845 0.6565,1.495 z m 5.96,3.965 c 0.5113,0 0.9728,-0.1105 1.3845,-0.3315 0.4117,-0.221 0.7432,-0.5222 0.9945,-0.9035 l 0.091,1.105 h 0.975 v -9.88 h -1.105 v 4.212 C 52.6427,13.3117 52.3133,13.03 51.906,12.822 51.4987,12.614 51.0523,12.51 50.567,12.51 c -0.5893,0 -1.131,0.1517 -1.625,0.455 -0.494,0.3033 -0.884,0.7215 -1.17,1.2545 -0.286,0.533 -0.429,1.1245 -0.429,1.7745 0,0.6413 0.1408,1.2285 0.4225,1.7615 0.2817,0.533 0.6673,0.9512 1.157,1.2545 0.4897,0.3033 1.0335,0.455 1.6315,0.455 z m 0.143,-0.975 c -0.4333,0 -0.8212,-0.1062 -1.1635,-0.3185 -0.3423,-0.2123 -0.6088,-0.507 -0.7995,-0.884 -0.1907,-0.377 -0.286,-0.8082 -0.286,-1.2935 0,-0.4767 0.0932,-0.9035 0.2795,-1.2805 0.1863,-0.377 0.4485,-0.676 0.7865,-0.897 0.338,-0.221 0.7323,-0.3315 1.183,-0.3315 0.442,0 0.8363,0.1083 1.183,0.325 0.3467,0.2167 0.6132,0.5157 0.7995,0.897 0.1863,0.3813 0.2795,0.806 0.2795,1.274 0,0.468 -0.0932,0.8927 -0.2795,1.274 -0.1863,0.3813 -0.4528,0.6825 -0.7995,0.9035 -0.3467,0.221 -0.741,0.3315 -1.183,0.3315 z m 12.284,0.975 c 0.5893,0 1.131,-0.1517 1.625,-0.455 0.494,-0.3033 0.884,-0.7215 1.17,-1.2545 0.286,-0.533 0.429,-1.1245 0.429,-1.7745 0,-0.65 -0.143,-1.2393 -0.429,-1.768 C 65.49,13.6843 65.1022,13.2683 64.6125,12.965 64.1228,12.6617 63.579,12.51 62.981,12.51 c -0.4853,0 -0.9295,0.104 -1.3325,0.312 -0.403,0.208 -0.7345,0.494 -0.9945,0.858 V 9.455 h -1.105 v 9.88 h 1.001 l 0.065,-1.079 c 0.2513,0.3727 0.585,0.6673 1.001,0.884 0.416,0.2167 0.871,0.325 1.365,0.325 z m -0.13,-0.975 c -0.4333,0 -0.8233,-0.1105 -1.17,-0.3315 -0.3467,-0.221 -0.6153,-0.52 -0.806,-0.897 -0.1907,-0.377 -0.286,-0.7995 -0.286,-1.2675 0,-0.468 0.0953,-0.8927 0.286,-1.274 0.1907,-0.3813 0.4615,-0.6825 0.8125,-0.9035 0.351,-0.221 0.7475,-0.3315 1.1895,-0.3315 0.442,0 0.832,0.1105 1.17,0.3315 0.338,0.221 0.598,0.5222 0.78,0.9035 0.182,0.3813 0.273,0.8103 0.273,1.287 0,0.4853 -0.0975,0.9165 -0.2925,1.2935 -0.195,0.377 -0.4615,0.6695 -0.7995,0.8775 -0.338,0.208 -0.7237,0.312 -1.157,0.312 z M 70.774,22 c 0.9273,0 1.6467,-0.2903 2.158,-0.871 0.5113,-0.5807 0.767,-1.3823 0.767,-2.405 V 12.64 h -1.105 v 3.497 c 0,0.3467 -0.0585,0.6955 -0.1755,1.0465 -0.117,0.351 -0.3142,0.6478 -0.5915,0.8905 -0.2773,0.2427 -0.6327,0.364 -1.066,0.364 -0.5373,0 -0.9403,-0.1257 -1.209,-0.377 -0.2687,-0.2513 -0.403,-0.6977 -0.403,-1.339 V 12.64 h -1.105 v 4.355 c 0,0.7887 0.2102,1.3867 0.6305,1.794 0.4203,0.4073 1.0162,0.611 1.7875,0.611 0.468,0 0.8862,-0.1062 1.2545,-0.3185 0.3683,-0.2123 0.6608,-0.5222 0.8775,-0.9295 v 0.585 c 0,0.78 -0.1495,1.3672 -0.4485,1.7615 -0.299,0.3943 -0.7648,0.5915 -1.3975,0.5915 -0.39,0 -0.7128,-0.0715 -0.9685,-0.2145 -0.2557,-0.143 -0.4312,-0.3488 -0.5265,-0.6175 l -1.04,0.208 c 0.1647,0.4593 0.4702,0.8298 0.9165,1.1115 C 69.5758,21.8592 70.124,22 70.774,22 Z",
    fill: "#ffffff",
    id: "path1-0-0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2-0-5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "m 85.870244,21.774465 c 0.01222,0.07721 0.0347,0.151484 0.05875,0.225196 h 0.05059 c -2.2e-4,-5.93e-4 0.0011,-0.0011 8.16e-4,-0.0016 -0.03664,-0.07411 -0.07391,-0.148581 -0.11015,-0.223564 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5-0-2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "m 132.34778,21.295551 c -0.002,3.48e-4 -0.005,6.47e-4 -0.007,9.93e-4 2.3e-4,3.88e-4 3.7e-4,7.94e-4 5.9e-4,0.0012 0.002,-7.05e-4 0.005,-0.0015 0.007,-0.0022 z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.14359,-215.90734)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNttdataPowered);
export default __webpack_public_path__ + "static/media/nttdata-powered.6339351034abb795a27d614cfaee6fed.svg";
export { ForwardRef as ReactComponent };